import { ChangeEvent, Children, useEffect, useState } from 'react';

import Equipment from 'model/Equipment';
import { DEVICE_MODAL_TYPE } from 'types/enumType';
import { convertDeviceTypeToString } from 'util/commonUtil';

import QrcodeModal from './modal/QrcodeModal';

type EquipTableProps = {
  type: DEVICE_MODAL_TYPE;
  list: Equipment[];
  isAdmin: boolean;
  onRegister: (type: DEVICE_MODAL_TYPE) => void;
  onClickDetail: (type: DEVICE_MODAL_TYPE, id: number) => void;
  isAvailableDevice: (type: DEVICE_MODAL_TYPE) => boolean;
};

export default function EquipTable({
  type,
  list,
  isAdmin,
  isAvailableDevice,
  onRegister,
  onClickDetail,
}: EquipTableProps) {
  // checkbox checked -> device.code 로 qr코드 생성 (인쇄가능 페이지)
  // all checked

  /**
   * checked된 qrcode 목록 상태 저장
   * 단일 클릭시 해당 qrcode가져와서 insert/delete
   * 전체 선택 시 모든 qrcode insert/delete
   *
   * 생성 버튼 클릭 시 선택된 qr잇는지 확인 후 open
   *
   * 체크 박스 동작 기능 구현
   */

  /**
   * 설비 목록 변경 시 체크 박스 해제 및 qrlist 초기화
   */

  const [checkedEquipList, setCheckedEquipList] = useState<number[]>([]);
  const [isAllChecked, setIsAllChecked] = useState<boolean>(false);

  const onCheckedEquipItem = (
    event: ChangeEvent<HTMLInputElement>,
    equipId: number,
  ) => {
    if (event.target.checked) {
      setCheckedEquipList((prev) => prev.concat(equipId));
      if (checkedEquipList.concat(equipId).length === list.length) {
        setIsAllChecked(true);
      }
    } else {
      setCheckedEquipList((prev) => prev.filter((id) => id !== equipId));
      if (isAllChecked) {
        setIsAllChecked(false);
      }
    }
  };
  const toggleAllChecked = (event: ChangeEvent<HTMLInputElement>) => {
    setIsAllChecked(event.target.checked);

    if (event.target.checked) {
      setCheckedEquipList(list.map((item) => item.id));
    } else {
      setCheckedEquipList([]);
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const onClick = () => {
    setConfirmIsOpen(true);
  };
  // const confirmClose = () => {
  //   setConfirmIsOpen(false);
  // }

  const modalHandler = () => {
    if (checkedEquipList.length === 0) {
      alert('QR 코드를 생성할 설비를 선택해주세요');
      return;
    }

    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setConfirmIsOpen(false);
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  useEffect(() => {
    setIsAllChecked(false);
    setCheckedEquipList([]);
  }, [list]);

  return (
    <>
      <section>
        <div className={'subtit'}>
          <p>{convertDeviceTypeToString(type)}</p>
          <span>
            {isAdmin && (
              <button
                className={'orange_white_btn mg15r'}
                type={'button'}
                onClick={modalHandler}
              >
                {'QR코드 생성'}
              </button>
            )}
            {isAvailableDevice(type) && isAdmin && (
              <button
                className={'orange_white_btn'}
                type={'button'}
                onClick={() => onRegister(type)}
              >
                {'신규 추가'}
              </button>
            )}
          </span>
        </div>
        <div className={'tbl-wrap equip-wrap'}>
          <table className={'tbl_ht01'}>
            <colgroup>
              <col />
              <col width={'30%'} />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                {isAdmin && (
                  <th aria-label={'th'}>
                    <input
                      type={'checkbox'}
                      checked={isAllChecked}
                      onChange={toggleAllChecked}
                    />
                  </th>
                )}
                <th>{'설비 코드'}</th>
                <th>{'설비명'}</th>
                <th>{'MDM코드'}</th>
                <th>{'사용여부'}</th>
              </tr>
            </thead>
            <tbody>
              {!list || list?.length === 0 ? (
                <tr>
                  <td colSpan={5}>{'데이터가 없습니다.'}</td>
                </tr>
              ) : (
                Children.toArray(
                  list.map((device) => (
                    <tr
                      onClick={() => onClickDetail(type, device.id)}
                      className={device.activate === 'N' ? 'redrow' : ''}
                    >
                      {isAdmin && (
                        <td onClick={handleClick} aria-label={'td'}>
                          <input
                            type={'checkbox'}
                            data-code={device.code}
                            checked={
                              !!checkedEquipList.find(
                                (item) => item === device.id,
                              )
                            }
                            onChange={(event) =>
                              onCheckedEquipItem(event, device.id)
                            }
                          />
                        </td>
                      )}
                      <td>{device.itemCode}</td>
                      <td className={'left'}>{device.name}</td>
                      <td>{device.mdmCode}</td>
                      <td>{device.activate}</td>
                    </tr>
                  )),
                )
              )}
            </tbody>
          </table>
        </div>
      </section>
      <QrcodeModal
        equipIdList={checkedEquipList}
        isOpen={isOpen}
        onClose={handleClose}
        onClick={onClick}
        confirmIsOpen={confirmIsOpen}
      />
    </>
  );
}
